module.exports = __webpack_public_path__ + "static/forecast/weather/nightlightrain-780a8628432ec28f3cf6c4bcf895b334.svg";